import { Alert, Box, Button, Typography } from "@mui/material";

const RegenerationRequired = ({
  canRegenerate = false,
  count = 0,
  documentType = "sales-order",
  isLoading = false,
  onRegenerate,
}) => {
  const isEstimate = documentType === "estimate";
  const buttonLabel = isEstimate
    ? "Regenerate Estimate with Live Cart"
    : "Regenerate Sales Order with Live Cart";
  const documentLabel = isEstimate ? "estimate" : "sales order";

  return (
    <Box sx={{ py: 4 }}>
      <Alert severity={canRegenerate ? "warning" : "info"}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {canRegenerate ? "Cart Changes Are Awaiting Regeneration" : "Document Unavailable"}
        </Typography>
        <Typography variant="body2">
          {canRegenerate
            ? `This ${documentLabel} was created without captured products, but the live order cart now contains ${count} product(s). Regenerate the ${documentLabel} to capture the current products, pricing, decorations, artwork, taxes, and services.`
            : "This document is not currently available because no products were captured when it was created. Please contact your representative for an updated version."}
        </Typography>
        {canRegenerate ? (
          <Button
            sx={{ mt: 2 }}
            variant="contained"
            onClick={onRegenerate}
            disabled={isLoading}
          >
            {isLoading ? "Regenerating..." : buttonLabel}
          </Button>
        ) : null}
      </Alert>
    </Box>
  );
};

export default RegenerationRequired;
